module.exports = __webpack_public_path__ + "static/media/3.8a4d3d06.svg";